import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from "../../../Api/Types/tagTypes";
import { Region } from "../Types/regionTypes";

export const regionsApi = createGenericApiSlice<Region>({
	reducerPath: "regionsApi",
	tag: TagTypes.Region,
	endpoint: "regions",
});

export const {
	useGetAllQuery: useGetRegionsQuery,
	useGetByIdQuery: useGetRegionByIdQuery,
	useCreateMutation: useCreateRegionMutation,
	useUpdateMutation: useUpdateRegionMutation,
	useDeleteMutation: useDeleteRegionMutation,
} = regionsApi;
